module.exports = __webpack_public_path__ + "static/media/clear.d0ed3d24.gif";